import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCrudComponent } from '@app/admin/base-crud.component';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { CreateEditActionComponent } from '@app/core/windows'; 
// import { Socket } from 'ngx-socket-io';


@Component({
  selector: 'actions-crud',
  templateUrl: './actions-crud.component.html',
  providers: [ DatasourceService ]
})
export class ActionsCrudComponent extends BaseCrudComponent implements OnInit {

  @ViewChild(CreateEditActionComponent, {static: false}) window !: CreateEditActionComponent;

  protected menu: string = 'Acceso';

  protected menuIcon: string = 'gears';
  
  protected label: string = 'Acción';

  protected name: string = 'Acciones';

  protected table: string = 'actions';

  // protected event: string = 'ACCION';
  
  // constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, private socket: Socket) {
  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {    

    super(authService, service, alertService);
    console.log(this.constructor.name);
    this.breadcrumbItems = this.getBreadcumItems();

  } 
  
  //Overrides
  protected getInitialState() : State {

    let s = this.service.getStateEmpty();
    s.sort = [      
      {field: 'name', dir: 'asc'}
    ];

    return s;

  }

  ngOnInit() { 
    
    super.ngOnInit();  
    
    // this.socket.on(this.event + "_INSERTED", (data) => {
    //   console.log('SOCKET-EVENT', this.event + '_INSERTED', data);
    //   this.service.pagination(this.table, this.state);
    // });

    // this.socket.on(this.event + "_UPDATED", (data) => {
    //   console.log('SOCKET-EVENT', this.event + '_UPDATED', data);
    //   this.service.pagination(this.table, this.state);
    // });

    // this.socket.on(this.event + "_DELETED", (data) => {
    //   console.log('SOCKET-EVENT', this.event + '_DELETED', data);
    //   this.service.pagination(this.table, this.state);
    // });
  
  }

}